/** One rule for naming a person in the panel: full name, else username. */
export function personName(p: { first_name?: string | null; last_name?: string | null; username?: string | null } | null | undefined): string {
  if (!p) return '';
  const full = `${p.first_name ?? ''} ${p.last_name ?? ''}`.trim();
  return full || p.username || '';
}

/** Prefer a server-provided display name, fall back to the username, then a placeholder. */
export function nameOr(name: string | null | undefined, username: string | null | undefined, fallback = 'someone'): string {
  return (name && name.trim()) || (username && username.trim()) || fallback;
}
